import { makeStyles } from "tss-react/mui";
import { constants } from "../../../constants";

interface IStyles {
    backgroundImage: string;
}

export const useStyles = makeStyles<IStyles>()(
    (theme, { backgroundImage }) => ({
        root: {
            alignSelf: "center",
            width: "404px",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            color: constants.color.black,
            justifyContent: "left",
        },
        imageContainer: {
            width: "100%",
            height: "600px",
            marginBottom: "32px",
            position: "relative",
            display: "block",
            zIndex: 0,
            overflow: "hidden",
            backgroundColor: constants.color.black,
        },
        imageBackground: {
            display: "block",
            width: "inherit",
            height: "600px",
            flexDirection: "column",
            justifyContent: "left",
            backgroundImage,
            filter: "grayscale(100%)",
            backgroundPosition: "center top",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
            backgroundSize: "cover",
        },
        image: {
            display: "block",
            width: "72%",
            zIndex: 2,
            position: "absolute",
            top: "18%",
            left: "15%",
        },
        eyebrow: {
            fontFamily: "Gotham Book",
            fontSize: "14px",
            fontWeight: 450,
            lineHeight: "17.81px",
            letterSpacing: "1.424880862236023px",
            textAlign: "left",
            marginBottom: "9px",
            textTransform: "uppercase",
        },
        heading: {
            fontFamily: "Gotham Book",
            fontSize: "30px",
            fontWeight: 450,
            lineHeight: "32.06px",
            textAlign: "left",
            marginBottom: "16px",
            textTransform: "uppercase",
        },
        description: {
            fontFamily: "Galaxie Copernicus",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "26px",
            textAlign: "left",
            fontStyle: "normal",
        },
    })
);
